document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-size-chart-trigger]');

  if (!trigger) return;

  event.preventDefault();

  const accordion = document.querySelector(
    '.helm-size-chart-accordion'
  );

  if (!accordion) return;

  const details = accordion.querySelector('details');
  const summary = accordion.querySelector('summary');

  if (!details || !summary) return;

  if (!details.open) {
    summary.click();
  }

  window.setTimeout(() => {
    accordion.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }, 150);
});

const updateProductRtb = () => {
  const carousel = document.querySelector(
    '.product__column-sticky media-gallery gallery-carousel .main-carousel'
  );

  const rtbs = document.querySelectorAll('.helm-product-rtb');

  if (!carousel || !rtbs.length) return;

  if (window.innerWidth <= 767) {
    rtbs.forEach((rtb) => {
      rtb.style.width = '';
      rtb.style.marginRight = '';
      rtb.style.marginLeft = '';
    });

    return;
  }

  const carouselRect = carousel.getBoundingClientRect();

  rtbs.forEach((rtb) => {
    rtb.style.width = `${carouselRect.width}px`;
    rtb.style.marginLeft = 'auto';
  });
};

const initHelmProductSwatches = () => {
  document
    .querySelectorAll(
      '.product .product__info-wrapper fieldset.product__siblings .variant-picker'
    )
    .forEach((slider) => {
      if (slider.dataset.helmDragInitialized === 'true') return;

      slider.dataset.helmDragInitialized = 'true';

      let isDown = false;
      let hasDragged = false;
      let blockClick = false;
      let startX = 0;
      let startScrollLeft = 0;

      const activeSwatch = slider.querySelector('.swatch-image.active');

      if (activeSwatch) {
        requestAnimationFrame(() => {
          const sliderRect = slider.getBoundingClientRect();
          const swatchRect = activeSwatch.getBoundingClientRect();

          if (
            swatchRect.left < sliderRect.left ||
            swatchRect.right > sliderRect.right
          ) {
            activeSwatch.scrollIntoView({
              behavior: 'auto',
              block: 'nearest',
              inline: 'nearest'
            });
          }
        });
      }

      slider.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        if (slider.scrollWidth <= slider.clientWidth) return;

        isDown = true;
        hasDragged = false;
        blockClick = false;

        startX = event.clientX;
        startScrollLeft = slider.scrollLeft;

        slider.classList.add('is-dragging');

        event.preventDefault();
      });

      window.addEventListener('mousemove', (event) => {
        if (!isDown) return;

        const distance = event.clientX - startX;

        if (Math.abs(distance) > 4) {
          hasDragged = true;
          blockClick = true;
        }

        if (!hasDragged) return;

        slider.scrollLeft = startScrollLeft - distance;
      });

      const stopDragging = () => {
        if (!isDown) return;

        isDown = false;
        slider.classList.remove('is-dragging');
      };

      window.addEventListener('mouseup', stopDragging);

      slider.addEventListener(
        'click',
        (event) => {
          if (!blockClick) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          blockClick = false;
          hasDragged = false;
        },
        true
      );

      slider.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });
    });
};

const initHelmProduct = () => {
  updateProductRtb();
  initHelmProductSwatches();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHelmProduct);
} else {
  initHelmProduct();
}

window.addEventListener('load', initHelmProduct);
window.addEventListener('resize', updateProductRtb);

document.addEventListener('shopify:section:load', () => {
  initHelmProduct();
});